import 'reset-css';
import 'native-promise-only';

import './base.css';
import './drupal.css';
import './components/basicHero';
import './components/betaHeader';
import './components/lamdaField';
import './components/breadcrumbs';
import './components/courseHero';
import './components/profileHero';
import './components/promoBlock';
import './components/ctaBlock';
import './components/ctaButtons';
import './components/footer';
import './components/header';
import './components/googleSearchResults';
import './components/slice';
import './components/textBlockTwo';
import './components/textImage';
import './components/textures';
import './components/teaser';
import './components/unistats';
import './components/categoryCard';
import './components/categoryList';
import './components/spektrixEmbed';
import './components/spektrixDonate';
import './components/spektrixMembership';
import './components/downloadButton';
import './components/policySummaryCard';
import './components/testimonialBlock';
import './components/teacherProfile';
import './components/teacherListing';
import './components/textBlock';
import './components/richText';
import './components/chatWebform';

import cookiePolicy from './components/cookiePolicy';
import accordion from './components/accordion';
import eventShowings from './components/eventShowings';
import processBlock from './components/processBlock';
import gridGuide from './components/gridGuide';
import mediaEmbed from './components/mediaEmbed';
import vimeoEmbed from './components/vimeoEmbed';
import navigation from './components/navigation';
import purchaseBlock from './components/purchaseBlock';
import stickyNav from './components/stickyNav';
import teaserList from './components/teaserList';
import highlightOverlay from './components/highlightOverlay';
import imageGallery from './components/imageGallery';
import spektrixBasket from './components/spektrixBasket';
import spektrixDonate from './components/spektrixDonate';
import spektrixMembership from './components/spektrixMembership';
import youtubeEmbed from './components/youtubeEmbed';
import tableComponent from './components/tableComponent';

function run() {
  cookiePolicy();
  accordion();
  eventShowings();
  processBlock();
  gridGuide();
  mediaEmbed();
  vimeoEmbed();
  navigation();
  // purchaseBlock();
  stickyNav();
  teaserList();
  imageGallery();
  spektrixBasket();
  spektrixDonate();
  spektrixMembership();
  youtubeEmbed();
  tableComponent();
}

window.addEventListener('DOMContentLoaded', () => {
  if (
    !Array.prototype.keys ||
    !Array.from ||
    !Array.prototype.includes ||
    !('scrollBehavior' in document.documentElement.style)
  ) {
    Promise.all([
      import('core-js/features/array/from'),
      import('core-js/features/array/keys'),
      import('core-js/features/array/includes'),
      import('core-js/features/object/assign'),
      import('core-js/web/dom-collections'),
      import('whatwg-fetch'),
      import('seamless-scroll-polyfill/dist/es5/seamless.js').then(({ polyfill }) => polyfill()),
    ]).then(run);
  } else {
    run();
  }
});
